var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('Navigation_bar'),_c('div',[_c('v-main',[_c('router-view')],1)],1),_c('Pre_footer'),_c('Footer'),_c('Whatsapp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }